import { makeStyles } from '@material-ui/styles';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { ReactComponent as FPSIcon } from '@/assets/icons/fps-big.svg';
import { HeaderTitle, Space } from '@/components';
import { StatusLayout } from '@/layout';
import { makeSelectIsMobileView } from '@/model/global/selectors';
import ResultFields from '@/pages/withdrawal/pages/StatusPage/components/ResultFields';
import { TransactionFields } from '@/pages/withdrawal/pages/StatusPage/components/ResultFields/types';

const useStyles = makeStyles(() => ({
  headerBox: {
    overflow: 'visible',
    flexShrink: 0,
    alignItems: 'center',
    textAlign: 'center',
  },
  fieldsBox: {
    overflow: 'auto',
    flex: 1,
  },
}));

interface ProgressViewProps {
  'data-test'?: string;
  transaction: TransactionFields;
  action?: ReactNode;
}

const selectIsMobile = makeSelectIsMobileView();

export const ProgressView: React.FC<ProgressViewProps> = ({ transaction, action, 'data-test': dataTest }) => {
  const classes = useStyles();
  const isMobile = useSelector(selectIsMobile);
  return (
    <StatusLayout
      data-test={dataTest && `${dataTest}-layout`}
      minHeight={400}
      height={700}
      status="progress"
      header={{
        title: (
          <HeaderTitle
            data-test={dataTest && `${dataTest}-title`}
            title={<FormattedMessage id="withdrawal.pages.result.title" />}
            postfix={isMobile && <FPSIcon />}
          />
        ),
      }}
      footer={{
        component: action && (
          <Space direction="vertical" size={2} style={{ alignItems: 'center' }}>
            {action}
          </Space>
        ),
      }}
    >
      <Space direction="vertical" size={4}>
        <ResultFields data-test={dataTest && `${dataTest}-fields`} data={transaction} className={classes.fieldsBox} />
      </Space>
    </StatusLayout>
  );
};

export default ProgressView;
